import React from "react";
import PlaceForm from "./PlaceForm";

export default function AddPlacePage() {
  return <PlaceForm type="Add" />;
}
